/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PresentationItem_presentation = {
    readonly rowId: string;
    readonly description: string | null;
    readonly title: string;
    readonly presenterFirstName: string | null;
    readonly presenterLastName: string | null;
    readonly prettyUrl: string;
    readonly presenter: {
        readonly slugId: string;
        readonly firstName: string;
        readonly lastName: string;
        readonly " $fragmentRefs": FragmentRefs<"UserPrimaryPhoto_user">;
    } | null;
    readonly " $refType": "PresentationItem_presentation";
};
export type PresentationItem_presentation$data = PresentationItem_presentation;
export type PresentationItem_presentation$key = {
    readonly " $data"?: PresentationItem_presentation$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PresentationItem_presentation">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationItem_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "presenter",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slugId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserPrimaryPhoto_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};
(node as any).hash = '442b11afad420521568cc82993e148bf';
export default node;
